import React, { useCallback, useState } from 'react';
import { Button, IconClose, Modal, Radio } from 'takeat-design-system-ui-kit';
import {
  ContainerBalance,
  ContainerBody,
  ContainerHeader,
  ContainerTxt,
  FooterBalance,
  InfoBalance,
  TextBalance,
  TitleBody,
  TitleHeader,
} from './styles';
import balanceToledo from '../../../../assets/img/balanceToledo.svg';
import balanceFilizola from '../../../../assets/img/balanceFilizola.svg';
import api from '~/services/api';
import toast from 'react-hot-toast';

export function DownloadProductTxt({ open, onClose }) {
  const [isDownload, setDownload] = useState(false);
  const [model, setModel] = useState(null);

  const downloadTxt = useCallback(async () => {
    if (!model) {
      toast.error('Selecione um modelo de balança');
      return;
    }
    console.log(model);

    setDownload(true);
    try {
      const response = await api.get(`restaurants/balance/txt?type=${model}`);

      const element = document.createElement('a');
      const file = new Blob([response.data], {
        type: 'text/plain;charset=utf-8',
      });
      element.href = URL.createObjectURL(file);
      element.download = `Produtos balanca.txt`;
      document.body.appendChild(element);
      element.click();
      setDownload(false);
    } catch (err) {
      setDownload(false);
      toast.error('Erro ao fazer download do SPED.');
    }
  }, [model]);

  return (
    <Modal
      open={open}
      toggle={onClose}
      style={{
        height: 'auto',
        width: '490px',
      }}
    >
      <ContainerTxt>
        <ContainerHeader>
          <TitleHeader>Download do arquivo de balança</TitleHeader>
          <IconClose
            style={{ cursor: 'pointer' }}
            onClick={onClose}
            fontSize={24}
          />
        </ContainerHeader>

        <TitleBody>
          Selecione o modelo da balança para gerar o arquivo .TXT
        </TitleBody>
        <ContainerBody>
          <ContainerBalance>
            <InfoBalance>
              <Radio
                checked={model === 'toledo'}
                onClick={() => setModel('toledo')}
                label="Toledo"
              />
              <TextBalance>
                Modelo compatível com balanças Toledo Prix e similares.
                Recomendado para equipamentos da marca Toledo.
              </TextBalance>
            </InfoBalance>
            <img src={balanceToledo} />
          </ContainerBalance>
          <ContainerBalance>
            <InfoBalance>
              <Radio
                checked={model === 'filizola'}
                onClick={() => setModel('filizola')}
                label="Filizola"
              />
              <TextBalance>
                Modelo compatível com balanças Filizola URANO. Use se sua
                balança for Filizola ou similares.
              </TextBalance>
            </InfoBalance>
            <img src={balanceFilizola} />
          </ContainerBalance>
        </ContainerBody>
        <FooterBalance>
          <Button variant="outlined" type="button" onClick={onClose}>
            Cancelar
          </Button>

          <Button
            style={{ width: '94px' }}
            isLoading={isDownload}
            onClick={downloadTxt}
            disabled={!model}
          >
            Baixar
          </Button>
        </FooterBalance>
      </ContainerTxt>
    </Modal>
  );
}
